import type { CountryData } from 'react-phone-input-2';

const DEFAULT_PHONE_LENGTH = 9;

const PHONE_COUNTRIES_LENGTH: { [key: string]: number } = {
  IL: 9,
  US: 10,
};

export const isValidPhone = (phoneNumber: string, selectedCountry: CountryData): boolean => {
  const { countryCode, dialCode } = selectedCountry;
  const phoneCountryLength =
    PHONE_COUNTRIES_LENGTH?.[countryCode.toUpperCase()] ?? DEFAULT_PHONE_LENGTH;

  return (phoneNumber?.replace?.(dialCode, '') ?? '')?.trim()?.length === phoneCountryLength;
};

export const PHONE_VALIDATION_MSG = 'The number is invalid';

export const cleanPhoneNumber = (phoneNumber: string): string => phoneNumber.replace(/\D/g, '');

export const getPrefillMobilePhoneNumber = (personalInfo: {
  isPhoneNumberMobile?: boolean;
  verifiedPhoneNumber?: string;
}): string =>
  personalInfo.isPhoneNumberMobile && personalInfo.verifiedPhoneNumber
    ? cleanPhoneNumber(personalInfo.verifiedPhoneNumber)
    : '';
